import $ from 'jquery'
import Base from 'luminate/src/modules/base'

// The class names of the various states the float label can have
const classes = {
	input:    '-type-input',
	select:   '-type-select',
	textarea: '-type-textarea',
	focused:  'is-focused',
	filled:   'is-filled',
	invalid:  'is-invalid',
	scrolled: 'is-scrolled'
}

/**
 * Applies the correct class names to the field
 * @param e - The event object
 */
function setState(e)
{
	const field = $(this)

	if(field.is('input[type="file"]'))
	{
		const div = field.siblings('div')
		let fileName = ''

		if(this.files && this.files.length > 1)
		{
			fileName = `${this.files.length} files selected`
		}
		else
		{
			fileName = this.value.split('\\').pop()
		}

		div.html(fileName)
	}

	// Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
	// problem with the "keydown" event in that the key value is added to the field after the event has been
	// called. This means the value of the field returned will be the previous value. The timeout ensures that
	// the input happens before the value is checked.
	setTimeout(function()
	{
		field.closest(FloatLabel.getSelector())

			// Set the field type as a class to the float label wrapper
			.addClass(classes[field.prop('tagName').toLowerCase()])

			// Is the element in focus?
			.toggleClass(classes.focused, (e.type == 'focus') || field.is(':focus'))

			// Check if the fields value is an empty string. This works for select options that have an empty
			// value. This can be exploited by creating an empty option, disabling it and setting it as the
			// default.
			.toggleClass(classes.filled, !!field.val())

			// Only apply if browser supports field validation
			.toggleClass(classes.invalid, field[0].validity ? !field[0].validity.valid : false)

			// Specifically for textarea's. This is useful so that the label can be hidden when the content is
			// scrolled, so that the label and the fields text don't overlap and look ugly.
			.toggleClass(classes.scrolled, field.scrollTop() > 0)

	})
}

const FloatLabel = Base.extend({
	directive: 'float-label',

	events: {

		init: function()
		{
			$(this.$element).find('input, select, textarea')

				// Add events to fields
				.on('focus blur change keyup keydown scroll', setState)

				// Set states on the page load.
				.each(setState)
		}
	}
})

export default FloatLabel



// WEBPACK FOOTER //
// ./source/scripts/modules/float-label.js